<template>
  <div class="br-empty-banner">
    <img
      :src="iconUrl"
      class="br-empty-banner-icon"
      width="20"
      height="20"
      alt=""
    />
    <p class="br-empty-banner-text">
      {{ $t('lbl_EMPBE_BR_Empty_NoBrFound_message') }}
    </p>
  </div>
</template>

<script>
import { BR_LICENSE_ASSETS } from '../../../constants/brLicenseAssets';

export default {
  name: 'BrEmptyBanner',
  computed: {
    iconUrl() {
      return BR_LICENSE_ASSETS.expirySoonAlertIcon;
    },
  },
};
</script>
